// Build mode and server capabilities.

export type AppMode = 'full' | 'client-only';
export const APP_MODE: AppMode = __APP_MODE__ === 'client-only' ? 'client-only' : 'full';

export interface ModelInfo {
  id: string;
  name?: string;
  license?: string;
  where?: string[];
  backend?: string;
}

export interface ServerLimits {
  maxSide: number;
  maxSeconds: number;
  maxFps: number;
  maxFrames: number;
}

export interface Capabilities {
  compute: boolean;
  gallery: boolean;
  models: ModelInfo[];
  limits?: ServerLimits;
}

export const caps = $state({
  loaded: false,
  serverReachable: false,
  compute: false,
  gallery: false,
  models: [] as ModelInfo[],
  limits: null as ServerLimits | null,
});

/** Fetches `/api/capabilities`; on failure the app runs client-only without gallery. */
export async function loadCapabilities(): Promise<void> {
  try {
    const r = await fetch('/api/capabilities', {
      headers: { accept: 'application/json' },
      signal: AbortSignal.timeout(5000),
    });
    if (!r.ok) throw new Error(String(r.status));
    const c = (await r.json()) as Capabilities;
    caps.serverReachable = true;
    caps.compute = APP_MODE === 'full' && !!c.compute;
    caps.gallery = !!c.gallery;
    caps.models = c.models ?? [];
    caps.limits = c.limits ?? null;
  } catch {
    caps.serverReachable = false;
    caps.compute = false;
    caps.gallery = false;
    caps.models = [];
  } finally {
    caps.loaded = true;
  }
}
